<div class="col-md-12">
    <table class="table">
        <thead>
            <tr>
                <th scope="col" style="width: 200px">
                    
                </th>
                <th scope="col">Betegnelse</th>
                <th scope="col">Handlinger</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let row of rows">
                <td>
                    <div *ngIf="row['image_filename'] != ''">
                        <img (click)="showFullImage(row['image_filename'])" class="imgThumb" [src]="'assets/images/thumbnails/'+row['image_filename']">
                    </div>
                </td>
                <td>
                    <a [routerLink]="['/showgear', row['id']]">
                        {{row['betegnelse']}}
                    </a>
                </td>
                <td>
                    <div class="btn-group float-right">
                        <button class="btn btn-sm btn-info" (click)="openEditGearDialog(+row['id'])">Rediger</button>
                        <button class="btn btn-sm btn-danger" (click)="deleteGear(+row['id'])">Slet</button>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
    <button class="btn btn-primary float-right" (click)="openAddGearDialog()">Tilføj udstyr</button>
</div>
